const middleware = {}

middleware['admin-unemployed'] = require('../../../middleware/admin-unemployed.js')
middleware['admin-unemployed'] = middleware['admin-unemployed'].default || middleware['admin-unemployed']

middleware['admin'] = require('../../../middleware/admin.js')
middleware['admin'] = middleware['admin'].default || middleware['admin']

middleware['auth'] = require('../../../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['check-state-job-announcement'] = require('../../../middleware/check-state-job-announcement.js')
middleware['check-state-job-announcement'] = middleware['check-state-job-announcement'].default || middleware['check-state-job-announcement']

middleware['check-user'] = require('../../../middleware/check-user.js')
middleware['check-user'] = middleware['check-user'].default || middleware['check-user']

middleware['company'] = require('../../../middleware/company.js')
middleware['company'] = middleware['company'].default || middleware['company']

middleware['create-occupation'] = require('../../../middleware/create-occupation.js')
middleware['create-occupation'] = middleware['create-occupation'].default || middleware['create-occupation']

middleware['maint'] = require('../../../middleware/maint.js')
middleware['maint'] = middleware['maint'].default || middleware['maint']

middleware['permissions'] = require('../../../middleware/permissions.js')
middleware['permissions'] = middleware['permissions'].default || middleware['permissions']

middleware['relink'] = require('../../../middleware/relink.js')
middleware['relink'] = middleware['relink'].default || middleware['relink']

middleware['selected-opportunity'] = require('../../../middleware/selected-opportunity.js')
middleware['selected-opportunity'] = middleware['selected-opportunity'].default || middleware['selected-opportunity']

middleware['selected-potential-workers'] = require('../../../middleware/selected-potential-workers.js')
middleware['selected-potential-workers'] = middleware['selected-potential-workers'].default || middleware['selected-potential-workers']

middleware['user-validate'] = require('../../../middleware/user-validate.js')
middleware['user-validate'] = middleware['user-validate'].default || middleware['user-validate']

export default middleware
